import { ChangeDetectorRef, Component, Input, NgZone, OnInit, SimpleChanges } from '@angular/core';
import { StringToDateAndRenewalPipe } from '../vdms_shared/pipes/renewal.status';
import { ListVehicleMastersModel } from '../vdms_core/model/vehicle.model';

@Component({
  selector: 'app-all-vehicles',
  templateUrl: './all-vehicles.component.html',
  styleUrls: ['./all-vehicles.component.css']
})
export class AllVehiclesComponent implements OnInit {
  

  @Input() inputAllVehiclesData: any;


  displayedColumns: string[] = [
    'vehicleNumber',
    'make',
    'model',
    'fuelType',
    'insurance',
    'lease',
    'action',
  ];

  //finduserData: RncUsersModel;
  // Pagination settings
  // pageSizeOptions: number[] = [25, 50, 75, 100];
  // pageSize: number = 25;
  // pageIndex: number = 0;
  // tempData: any;
  // activePage: 1;
  noOfItems = 10;

  /*************************************************************************
   * FILTER VARIABLE DECLARATION
   ************************************************************************/
  vehicleFilterModel: any = new Array();
  agencyFilterModel: any = new Array();
  carMakeFilterModel: any = new Array();
  carModelFilterModel: any = new Array();
  carFuelFilterModel: any = new Array();
  carTypeFilterModel: any = new Array();
  insuranceFilterModel: any = new Array();
  leaseFilterModel: any = new Array();


  vehicleFilterData: any = [];
  agencyFilterData: any = [];
  carMakeFilterData: any = [];
  carModelFilterData: any = [];
  carFuelFilterData: any = [];
  carTypeFilterData: any = [];
  insuranceFilterData: any = [];
  leaseFilterData: any = [];


  columnfilter = {

    veh_reg_id: {
      singleSelection: false,
      idField: "veh_reg_id",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    angency_name: {
      singleSelection: false,
      idField: "agencyName",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Agency Name.",
    },
    car_make: {
      singleSelection: false,
      idField: "car_make",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    car_model: {
      singleSelection: false,
      idField: "car_model",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    fuel_type: {
      singleSelection: false,
      idField: "fuel_type",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    car_type: {
      singleSelection: false,
      idField: "car_type",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    policy_no: {
      singleSelection: false,
      idField: "policy_no",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    lease_to: {
      singleSelection: false,
      idField: "lease_to",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
  }

  sortKey: string = "veh_reg_id"; //set default
  sortReverse: boolean = false;
  filteredVehicles: any[] = [];  // Filtered vehicles list
  constructor(
    private cdRef: ChangeDetectorRef,
    private zone: NgZone,
    private stringToDateAndRenewalPipe: StringToDateAndRenewalPipe) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.inputAllVehiclesData && Array.isArray(changes.inputAllVehiclesData.currentValue)) {
      console.log('unASSIGNED_CAR', this.inputAllVehiclesData);
      this.filteredVehicles = [...this.inputAllVehiclesData];
      console.log('filteredVehicles', this.filteredVehicles)
      this.initializeFilterData(true);
    }
  }


  ngAfterViewInit() {
    if (!this.inputAllVehiclesData) {
      setTimeout(() => {
        if (Array.isArray(this.inputAllVehiclesData) && this.inputAllVehiclesData.length > 0) {
          console.log('UNASSIGNED_CAR', this.inputAllVehiclesData);
          this.initializeFilterData(true);
        }
      }, 0);
    }
  }

  /*************************************************************************
   * FILTER FUNCTION DECLARATION
   ************************************************************************/

  private pushIfValid(arr: any[], value: any): void {
    if (value != null && !arr.includes(value)) {
      arr.push(value);
    }
  }

  initializeFilterData(isData: boolean) {
    console.log('initializeFilterData')
    // Clear the filter data arrays

    this.vehicleFilterData = [];
    this.agencyFilterData = [];
    this.carMakeFilterData = [];
    this.carModelFilterData = [];
    this.carFuelFilterData = [];
    this.carTypeFilterData = [];
    this.insuranceFilterData = [];
    this.leaseFilterData = [];

    // const insuranceStatus = this.stringToDateAndRenewalPipe.transform(dSheets.policy_to);
    // const leaseStatus = this.stringToDateAndRenewalPipe.transform(dSheets.lease_to);
    // Populate the filter data arrays
    for (const item of this.inputAllVehiclesData) {
      const insuranceStatus = this.stringToDateAndRenewalPipe.transform(item.policy_to);
      const leaseStatus = this.stringToDateAndRenewalPipe.transform(item.lease_to);

      this.pushIfValid(this.vehicleFilterData, item.veh_reg_id);
      this.pushIfValid(this.agencyFilterData, item.agencyName);
      this.pushIfValid(this.carMakeFilterData, item.car_make);
      this.pushIfValid(this.carModelFilterData, item.car_model);
      this.pushIfValid(this.carFuelFilterData, item.fuel_type);
      this.pushIfValid(this.carTypeFilterData, item.car_type);
      this.pushIfValid(this.insuranceFilterData, `${insuranceStatus.status}`);
      this.pushIfValid(this.leaseFilterData, `${leaseStatus.status}`);

    }



    // Update dropdown data with proper change detection
    const updateDropdownData = () => {
      this.vehicleFilterData = [...this.vehicleFilterData];
      this.agencyFilterData = [...this.agencyFilterData];
      this.carMakeFilterData = [...this.carMakeFilterData];
      this.carModelFilterData = [...this.carModelFilterData];
      this.carFuelFilterData = [...this.carFuelFilterData];
      this.carTypeFilterData = [...this.carTypeFilterData];
      this.insuranceFilterData = [...this.insuranceFilterData];
      this.leaseFilterData = [...this.leaseFilterData];

      // this.carMakeFilterData = [...this.carMakeFilterData]; // Ensures array is re-referenced
      // this.carModelFilterData = [...this.carModelFilterData];

      this.cdRef.detectChanges(); // Trigger change detection manually if needed
    };

    console.log('filter data added', this.carMakeFilterData);
    console.log('filter data added', this.carModelFilterData);

    if (isData) {
      // Update immediately when `isData` is true
      updateDropdownData();
    } else {
      // Use Angular's `zone` to avoid ExpressionChangedAfterItHasBeenCheckedError
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          this.zone.run(() => {
            updateDropdownData();
          });
        }, 15000);
      });
    }
  }


  onFilterChange() {
    console.log('onfilterchange')

    const filtered = this.inputAllVehiclesData.filter(vehicle => {
      const insuranceStatus = this.stringToDateAndRenewalPipe.transform(vehicle.policy_to).status;
      const leaseStatus = this.stringToDateAndRenewalPipe.transform(vehicle.lease_to).status;

       // Helper function to check if a value matches the filter
       const matchesFilter = (filter: any[], value: any) =>
        !filter.length || filter.includes(value);

      // Checking if the vehicle matches all filters
      const matchVehicle = matchesFilter(this.vehicleFilterModel, vehicle.veh_reg_id);
      const matchAgency = matchesFilter(this.agencyFilterModel, vehicle.agencyName);
      const matchCarMake = matchesFilter(this.carMakeFilterModel, vehicle.car_make);
      const matchCarModel = matchesFilter(this.carModelFilterModel, vehicle.car_model);
      const matchCarFuel = matchesFilter(this.carFuelFilterModel, vehicle.fuel_type);
      const matchCarType = matchesFilter(this.carTypeFilterModel, vehicle.car_type);
      const matchInsurance = matchesFilter(this.insuranceFilterModel, insuranceStatus);
      const matchLease = matchesFilter(this.leaseFilterModel, leaseStatus);

      // Return true only if all criteria match
      return (
        matchVehicle &&
        matchAgency &&
        matchCarMake &&
        matchCarModel &&
        matchCarFuel &&
        matchCarType &&
        matchInsurance &&
        matchLease
      );

      // const matchVehicle = !this.vehicleFilterModel.length ||
      //   this.vehicleFilterModel.includes(vehicle.veh_reg_id);
      // const matchCarMake = !this.carMakeFilterModel.length ||
      //   this.carMakeFilterModel.includes(vehicle.car_make);
      // const matchCarModel = !this.carModelFilterModel.length ||
      //   this.carModelFilterModel.includes(vehicle.car_model);
      // const matchDriverName = !this.carFuelFilterModel.length ||
      //   this.carFuelFilterModel.includes(vehicle.car_fuel);
      // const matchCarType = !this.carTypeFilterModel.length ||
      //   this.carTypeFilterModel.includes(vehicle.car_type);
      // const matchInsurance = !this.insuranceFilterModel.length ||
      //   this.insuranceFilterModel.includes(insuranceStatus);
      // const matchLease = !this.leaseFilterModel.length ||
      //   this.leaseFilterModel.includes(leaseStatus);
      // this.cdRef.detectChanges();
      // return matchVehicle && matchCarMake && matchCarType && matchInsurance && matchLease;
    });

    if (filtered.length === 0) {
      alert('No matching vehicles found!')
    }

    if (filtered.length > 0) {
      this.filteredVehicles = filtered
    }
    // alert('No matching vehicles found!'+this.filteredVehicles.length);
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return 'fa fa-sort-desc';
      }
      else {
        return 'fa fa-sort-asc';
      }
    }
    else {
      return 'fa fa-sort';
    }

  }
}
